import { getDeployArea, getDeployEnv } from "@ti/max";
import { printAppInfo } from "@/tiMax/utils/initConsole";
import * as Arms from "@/tiMax/utils/arms";
import DownloadStatusPolling from "@/utils/DownloadStatusPolling";

export async function getInitialState() {
  return {
    DownloadStatusPolling: new DownloadStatusPolling(),
  };
}

export const spiral = {
  microAppInitConfig: {
    excludeAssetFilter: (url: string) => {
      return ["maps.googleapis.com"].some((v) => url?.includes(v));
    },
    plugins: {
      global: [
        {
          escapeProperties: ["google"],
        },
      ],
    },
  },
};

printAppInfo();

const deployArea = getDeployArea();
const env = getDeployEnv();
const area = getDeployArea();

const armsPid = {
  cn: "gmpgmsbi3k@a4f0864d77500f6",
  eu: "gmpgmsbi3k@58587fcff93613a",
  sg: "gmpgmsbi3k@d0ab58009694ff1",
  us: "gmpgmsbi3k@c34036bc1ea7f19",
}[deployArea];

Arms.init(armsPid);
